import { css, extractShadow, extractTransition, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 16px;
    padding: 18px 24px;
    box-shadow: ${extractShadow((s) => s.robin2)};
    border: 1px solid ${theme.colors.neutral.variant[10]};
  `,
  logo: css`
    display: flex;
    align-items: center;
    gap: 12px;
  `,
  divisor: css`
    margin: 18px -14px 24px;
    width: calc(100% + 28px);
  `,
  vacancyDetails: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 16px;
    gap: 12px;
    color: ${theme.colors.primary.fuchsia[50]};
    border-radius: 14px;
    border: 1px solid ${theme.colors.primary.fuchsia[50]};
    cursor: pointer;

    ${extractTransition((f) => f.cubic, { property: ['border-color', 'color'], duration: 220 })}

    &:hover {
      border: 1px solid ${theme.colors.primary.fuchsia[60]};
      color: ${theme.colors.primary.fuchsia[60]};
    }
  `,
  vacancyDetailsTitle: ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 8px;

    color: ${theme.colors.neutral.variant[70]};
  `,
  vacancyDetailsView: css`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  message: css`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin: 36px 0;
  `,
  buttons: css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    width: 245px;
    align-self: center;
    pointer-events: none;
    margin-bottom: 24px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
